import React from 'react';
import {Link} from 'react-router-dom'

function LogoImage() {

    return <Link to={`/`} className="cpr-logo">
                <img src={`${process.env.PUBLIC_URL}/assets/images/Logo5.png`} alt="City Premium Realty"
                     width="2094" height="476"/>
            </Link>;
}
export default LogoImage;
